import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import "./sitenav.css";

const SiteNav: React.FC = () => {
  const { user, username, logout } = useUser();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const scrollTo = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  const goToTeams = () => {
    setOpen(false);
    if (pathname === '/') {
      document.getElementById('tribes')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: 'tribes' } });
    }
  };

  const handleLogout = async () => {
    setOpen(false);
    try {
      await logout();
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <>
      <nav className="home-nav">
        <a
          href="#"
          className="nav-logo"
          onClick={(e) => {
          e.preventDefault();
          if (pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            navigate('/');
          }
        }}
        >TRIBELET</a>
        <div className="nav-links">
          <a href="/#tribes" onClick={scrollTo('tribes')}>Tribes</a>
          <a href="/#how" onClick={scrollTo('how')}>Process</a>
          <a href="/#manifesto" onClick={scrollTo('manifesto')}>Story</a>
        </div>
        {user ? (
          <button className="nav-cta" onClick={() => setOpen(o => !o)}>
            {username}
          </button>
        ) : (
          <Link to="/account" className="nav-cta">Sign In →</Link>
        )}
      </nav>

      {open && (
        <div className="nav-dropdown">
          <Link to="/profile" className="nav-dropdown-item" onClick={() => setOpen(false)}>
            My Profile
          </Link>
          <Link to="/orders" className="nav-dropdown-item" onClick={() => setOpen(false)}>
            My Orders
          </Link>
          <button className="nav-dropdown-item" onClick={goToTeams}>
            My Teams
          </button>
          <div className="nav-dropdown-divider" />
          <button className="nav-dropdown-item danger" onClick={handleLogout}>
            Log Out
          </button>
        </div>
      )}

      {open && (
        <div className="nav-dropdown-backdrop" onClick={() => setOpen(false)} />
      )}
    </>
  );
};

export default SiteNav;
